import {
  AnotacaoType,
  AsoType,
  FatorRiscoType,
  ID,
  Response,
  ResultadoType,
  SituacaoAso,
  AtendimentoType,
  DispositivoType,
  EnvioType,
  PrescricaoType,
  PrescricaoSituation,
  ModalidadeType,
  NotificacaoType,
  SituacaoDiagnosticoType,
  SituacaoInterconsulta,
  TipoReceitaSncr,
  SituacaoTranscricaoType,
} from '../../../../../_metronic/helpers'
import { PessoaList } from '../../../auth'
import { CorTriagem } from '../../../../components/TriagemRisco/riscoTriagem'
import { UsuarioList } from '../../admin/usuarios/usuarios-list/core/_models'
import {
  AnexoDto,
  AtendimentoDtoProcedimento,
} from '../../atendimento_medicos/atendimentos-medico-list/core/_models'
import {
  AtestadoList,
  ExamePrescritoList,
  FormulaPrescritaList,
  MedicamentoPrescritoList,
  OrientacaoPrescritaList,
} from '../../atendimento_medicos/prescricao/core/_model'
import { FormularioAtendimentoList } from '../../avaliacoes/avaliacoes-pendentes-list/core/_models'
import { EmpresaList } from '../../empresa/empresas-list/core/_models'
import { ClienteList } from '../../empresa/empresasCliente-list/core/_models'
import { ColaboradorList } from '../../empresa/empresasClienteCoordenador-list/core/_models'
import {
  EspecialidadeDto,
  EspecialidadeList,
} from '../../especialidades/especialidades-list/core/_models'
import { FormularioDto } from '../../formularios/formularios-create/core/_models'
import {
  DadoAsoView,
  PacienteDto,
  PacienteList,
} from '../../paciente-management/pacientes-list/core/_models'
import { UnidadeList } from '../../unidades/unidades-list/core/_models'
import { LotacaoView } from '../../funcionarios/funcionarios-list/core/_lotacaoModels'

/** Cor e indicadores da triagem do atendimento na fila (T4 AC1); ausente quando não há triagem. */
export type TriagemFilaResumo = {
  corFila: CorTriagem
  corMotor: CorTriagem
  corEfetiva: CorTriagem
  corMantida: boolean
  vigenteRevisada: boolean
  protocoloEmValidacao: boolean
  quantidadeTriagens: number
  idTriagemVigente?: number
  sequenciaVigente?: number
}

export type AtendimentoList = {
  triagem?: TriagemFilaResumo | null
  retorno?: boolean
  tipoAso?: AsoType
  estado?: EstadoAtendimentoList
  resultado?: string
  inicio?: string
  termino?: string
  solicitacao?: string
  presencaPaciente?: string
  aceiteTermos?: string
  pacienteOnline?: boolean
  inicioFormatado?: string
  responsavel?: PessoaList
  responsavelInicial?: PessoaList
  presencaPacienteFormatada?: string
  paciente?: PacienteList
  protocolo?: string
  terminoFormatado?: string
  situacaoAso?: SituacaoAso
  especialidade?: EspecialidadeList
  empresa?: EmpresaList
  tipo?: AtendimentoType
  aceiteTermosFormatado?: string
  solicitacaoFormatada?: string
  assinaturaPacienteObrigatoria?: boolean
  id?: number
  unidade?: UnidadeList
  modalidade?: ModalidadeType
  tempoAtraso?: number
  situacaoDiagnostico?: SituacaoDiagnosticoType
  situacaoInterconsulta?: SituacaoInterconsulta
  lotacao?: LotacaoView
}

export type PrescricaoAtendimentoView = {
  dispensacoes: DispensacaoView[]
  dataValidadeFormatada?: string
  dataUtilizacaoFormatada?: string
  dataValidade?: string
  dataUtilizacao?: string
  lme?: number
  apac?: number
  atestado?: AtestadoList
  exames?: ExamePrescritoList[]
  formulas?: FormulaPrescritaList[]
  codigoAcesso?: string
  codigoPaciente?: string
  medicamentos?: MedicamentoPrescritoList[]
  orientacoes?: OrientacaoPrescritaList[]
  dataFormatada?: string
  descricao?: string
  tipo?: PrescricaoType
  anexo?: number
  situacao?: PrescricaoSituation
  id: number
  data?: string
  prescricaoApac?: boolean
  prescricaoLme?: boolean
  numeroSncr?: string | null
  tipoReceitaSncr?: TipoReceitaSncr | null
}

export type DispensacaoView = {
  crfUf?: string
  documento?: string
  farmacia?: string
  farmaceutico?: string
  dataFormatada?: string
  id: number
  data?: string
}

export type AtendimentoDtoBasic = {
  id: number
  protocolo?: string
  retorno?: boolean
  inicio?: string
  termino?: string
  inicioFormatado?: string
  terminoFormatado?: string
  tipo?: AtendimentoType
  especialidade?: EspecialidadeDto
  modalidade?: ModalidadeType
}

export type AtendimentoView = {
  cliente?: ClienteList
  retorno?: boolean
  tipoAso?: AsoType
  estado?: EstadoAtendimentoList
  resultado?: ResultadoType
  inicio?: string
  criador?: PessoaList
  termino?: string
  dadosAso?: DadoAsoView
  solicitacao?: string
  urlSalaVideo?: string
  presencaPaciente?: string
  aceiteTermos?: string
  pacienteOnline?: boolean
  inicioFormatado?: string
  responsavel?: PessoaList
  responsavelInicial?: PessoaList
  presencaPacienteFormatada?: string
  paciente?: PacienteList
  protocolo?: string
  dispositivos?: DispositivoList[]
  terminoFormatado?: string
  pcmsoCliente?: ColaboradorList
  pcmsoEmpresa?: PessoaList
  prescricoes?: PrescricaoAtendimentoView[]
  informacoes?: InformacaoAtendimentoView[]
  procedimentos?: ProcedimentoAtendimentoView[]
  fatoresRisco?: FatorRiscoAtendimentoView[]
  situacaoAso?: SituacaoAso
  formularios?: FormularioAtendimentoList[]
  especialidade?: EspecialidadeList
  empresa?: EmpresaList
  anexos?: AnexoAtendimentoView[]
  tipo?: AtendimentoType
  mensagens?: MensagemAtendimentoView[]
  anotacoes?: AnotacaoAtendimentoView[]
  cids?: CidAtendimentoView[]
  situacaoDiagnostico?: SituacaoDiagnosticoType
  situacaoInterconsulta?: SituacaoInterconsulta
  /** Assinatura do último parecer da interconsulta. */
  dhConclusaoInterconsulta?: string
  /**
   * Assinatura do primeiro parecer; não muda com réplica. Base do prazo de 72h: tempo de resposta
   * = dhPrimeiraRespostaInterconsulta - solicitacao.
   */
  dhPrimeiraRespostaInterconsulta?: string
  aceiteTermosFormatado?: string
  solicitacaoFormatada?: string
  assinaturaPacienteObrigatoria?: boolean
  id?: ID
  urlAtendimento?: string
  prescricoesMemed?: PrescricaoMemedView[]
  unidade?: UnidadeList
  modalidade?: ModalidadeType
  tempoAtraso?: number
  instrucoes?: string[]
  lotacao?: LotacaoView
  /** Interconsulta: lotação do solicitante carimbada na abertura (unidade, CBO, INE) — RATC. */
  lotacaoSolicitante?: LotacaoView
  /**
   * Interconsulta: quem solicitou (o funcionário gravado na abertura ou, no legado, o criador).
   * Nulo nos outros tipos — para eles vale o `criador`.
   */
  solicitante?: PessoaList
  /** Vínculo do solicitante; nulo no legado sem funcionário gravado. */
  idFuncionarioSolicitante?: number
  sessoesVideo?: SessaoVideoAtendimentoView[]
  /** Só as sessões encerradas. */
  tempoVideochamadaSegundos?: number
  tempoVideochamadaFormatado?: string
}

export type SessaoVideoAtendimentoView = {
  id?: ID
  inicio: string
  fim?: string | null
  duracaoSegundos?: number | null
  inicioFormatado?: string
  /** Sem fim: "Em andamento" ou "Fim não registrado". */
  fimFormatado?: string
  duracaoFormatada?: string | null
}

export type AtendimentoBase = {
  modalidadeAtendimento?: string
  terminoFormatado?: string
  retorno?: boolean
  inicio?: string
  termino?: string
  modalidade?: ModalidadeType
  solicitacaoFormatada?: string
  inicioFormatado?: string
  solicitacao?: string
  tipoAtendimento?: string
  protocolo?: string
  tipo?: AtendimentoType
  especialidade?: EspecialidadeList
  id: number
}

export type AtendimentoPacienteList = {
  prescricoesMemed?: PrescricaoMemedView[]
  prescricoes?: PrescricaoAtendimentoView[]
  retorno?: boolean
  tipoAso?: AsoType
  estado?: EstadoAtendimentoList
  resultado?: string
  inicio?: string
  termino?: string
  solicitacao?: string
  presencaPaciente?: string
  aceiteTermos?: string
  pacienteOnline?: boolean
  inicioFormatado?: string
  responsavel?: PessoaList
  presencaPacienteFormatada?: string
  paciente?: PacienteList
  protocolo?: string
  dispositivos?: DispositivoList[]
  terminoFormatado?: string
  situacaoAso?: SituacaoAso
  formularios?: FormularioAtendimentoList[]
  especialidade?: EspecialidadeList
  empresa?: EmpresaList
  tipo?: AtendimentoType
  aceiteTermosFormatado?: string
  solicitacaoFormatada?: string
  id?: ID
}

export type CidAtendimentoView = {
  id?: ID
  ordem?: number
  cid: CidList
}

export type TipoAnexoList = {
  descricao: string
  permiteListar: boolean
  permiteExcluir: boolean
  permiteIncluir: boolean
  id: ID
}

export type AnexoAtendimentoView = {
  dataFormatada: string
  permiteListar: boolean
  permiteExcluir: boolean
  permiteIncluir: boolean
  arquivo: ArquivoDto
  tipo: TipoAnexoList
  id: ID
  data: string
  url: string
  descricao?: string
}

export type ArquivoDto = {
  id: string
  name?: string
  type?: string
  length?: number
  contentBase64?: string
  url?: string
}

export type FatorRiscoAtendimentoView = {
  fatorRisco?: FatorRiscoType
  descricaoFatorRisco: string
  valor?: string
  id?: ID
}
export type TipoASO = {
  name?: string
  valor?: string
  descricao?: string
}
export type ProcedimentoAtendimentoView = {
  descricao?: string
  dataFormatada?: string
  anexo?: number
  nome?: string
  data?: string
  id: number
}
export type PendenciaAso = {
  atendimento?: string[]
  responsavel?: string[]
  paciente?: string[]
}

export type PrescricaoMemedView = {
  medicamentos?: MedicamentoPrescricaoList[]
  medico?: PessoaList
  memed?: string
  dataFormatada?: string
  anexo?: number
  id?: number
  data?: string
}

export type MedicamentoPrescricaoList = {
  nome?: string
  descricao?: string
  ordem?: number
  titulo?: string
  subTitulo?: string
  posologia?: string
  quantidade?: string
  id?: number
}

export type InformacaoAtendimentoView = {
  descricao: string
  unidade: string | null
  dataFormatada: string
  profissional: PessoaList
  valor: number | null
  dispositivo?: DispositivoList | null
  tipo: TipoInformacaoView
  id: ID
  anexo: number | null
  data: string
}

export type AtendimentoDtoInformacaoAgrupada = {
  id: ID | null | undefined
  dispositivo?: DispositivoList
  informacoes?: InformacaoAgrupada[]
}
export type TipoAtendimentoEmpresa = {
  descricao?: string
  name?: string
  valor?: string
}
export type InformacaoAgrupada = {
  id: number
  descricao: string
  unidade: string
  valor: number
  data: string
  dataFormatada: string
}

export type DispositivoList = {
  id: ID
  tipo: DispositivoType
  serie: string
  descricao: string
}

export type TipoInformacaoView = {
  descricao: string
  unidade: string | null
  ordem: ID
  siglaUnidade: string | null
  id: ID
}

export type EstadoAtendimentoList = {
  ativo: boolean
  nome: string
  descricao: string
  id: ID
}

/* export type Estado = {
  id?: ID
  nome?: string
  descricao?: string
  ativo?: string
  estadoInicial?: boolean
  estadoFinal?: boolean
  proximosEstados?: string[]
} */

export type AtendimentoDtoCid = {
  codigo: string
}
export type AtendimentoDtoFatorRisco = {
  fatorRisco: FatorRiscoType
  valor: string
}
export type AtendimentoDtoAnexo = {
  tipo: number
  data?: string
  fileContent: string
  fileName: string
  fileType: string
}
/**
 * Motivos que o backend pode devolver em `respostasZeradas[].motivo`.
 *
 * Enum de contrato: só cresce. Motivo desconhecido (versão mais nova do backend) é ignorado pela
 * tela, nunca quebra a renderização — por isso `motivo` é `string` e a checagem é em runtime.
 */
export const MOTIVOS_RESPOSTA_ZERADA_CONHECIDOS = ['REFERENCIA_ILEGIVEL'] as const

export type MotivoRespostaZerada = typeof MOTIVOS_RESPOSTA_ZERADA_CONHECIDOS[number]

/** Resposta apagada pelo backend na operação de escrita. Nunca traz o valor apagado. */
export type AtendimentoDtoRespostaZerada = {
  codigo: string
  rotulo: string
  motivo: string
}

export type AtendimentoDtoFormulario = {
  id?: number
  dataFormatada?: string
  respondido?: boolean
  formulario: FormularioDto
  /**
   * Respostas apagadas pela operação de escrita que devolveu este DTO.
   *
   * Ausente nos endpoints que não processam respostas; `[]` quando processou e não apagou nada.
   */
  respostasZeradas?: AtendimentoDtoRespostaZerada[]
}
export type AtendimentoDtoPrescricao = {
  identificadorPrescricao: string
  identificadoMedico: string
  data?: string
  medicamentos?: any[]
}
export type AtendimentoDtoInformacao = {
  tipo?: string
  descricao?: string
  unidade?: string
  dispositivoId?: number
  dispositivoSerie?: string
  valor: number
  anexo: AnexoDto
}
export type AtendimentoDtoMensagem = {
  mensagem: string
}

export type AtendimentoDtoAnotacao = {
  tipo:
    | 'ANAMNESE'
    | 'AVALIACAO'
    | 'DIAGNOSTICO'
    | 'TERAPIA'
    | 'OBSERVACAO'
    | 'PARECER'
    | 'PENDENCIA'
  anotacao: string
}

export type AnotacaoAtendimentoView = {
  anotacao?: string
  dataFormatada?: string
  tipo?: AnotacaoType
  usuario: UsuarioList
  data?: string
  id?: ID
}

export type MensagemAtendimentoView = {
  mensagem?: string
  dataFormatada?: string
  usuario?: PessoaList
  id?: number
  data?: string
}

export type CidList = {
  descricao?: string
  codigo?: string
  id?: ID
}

export type AtendimentoDtoDadosPaciente = {
  telefone?: string // pattern: \(\d{2}\) \d \d{4}-\d{4}
  tipoEnvio?: EnvioType
  email?: string
}

export type EnderecoDtoAtendimento = {
  /**
   * pattern: 00.000-000
   */
  cep: string
  logradouro: string
  numero: string
  complemento?: string
  bairro: string
  cidade: string
  /**
   * Sigla - RS
   */
  uf: string
  ativo?: boolean
  /**
   * Somente para identificação
   */
  nome: string
}

export type EnderecoAtendimento = {
  /**
   * Identificador único do endereço de atendimento.
   * - Presente somente quando o endereço já foi previamente cadastrado.
   * - Usado para diferenciar registros existentes de novos.
   */
  id?: number
  novo?: EnderecoDtoAtendimento
}

export type AtendimentoDtoCreate = {
  tipo: AtendimentoType
  modalidade: ModalidadeType
  tipoAso?: AsoType
  especialidade?: number
  unidade?: number
  cliente?: number
  pcmso?: number
  data?: string // tem que ser assim 2023-01-01 00:00:00
  retorno?: boolean
  endereco?: EnderecoAtendimento
  dadosPaciente?: AtendimentoDtoDadosPaciente
  tipoNotificacao?: NotificacaoType | null
  /**
   * Interconsulta: lotação do solicitante a carimbar no RATC. Só é preciso quando ele tem mais de
   * uma lotação vigente na unidade; com uma única, o backend carimba sozinho.
   */
  lotacaoSolicitante?: number
}

export type EstadoAtendimentoDto = {
  id?: number
  nome?: string
  descricao?: string
  ordem?: number
  ativo?: boolean
  estadoInicial?: boolean
  estadoFinal?: boolean
  estadoCancelado?: boolean
  estadoFalta?: boolean
  estadoPendente?: boolean
  estadoResolvido?: boolean
  proximosEstados?: EstadoAtendimentoDto[]
}

export interface AtendimentoDtoDadosAso {
  matricula?: string
  cargo: string
  setor: string
  cargoAso?: number
  setorAso?: number
}

export type AtendimentoDto = {
  id?: number
  tipo?: AtendimentoType
  tipoAso?: AsoType
  situacaoAso?: SituacaoAso
  situacaoInterconsulta?: SituacaoInterconsulta
  dhConclusaoInterconsulta?: string
  dhPrimeiraRespostaInterconsulta?: string
  resultadoAso?: ResultadoType
  protocolo?: string
  urlSalaVideo?: string
  retorno?: boolean
  avaliado?: boolean
  inicio?: string
  termino?: string
  solicitacao?: string
  aceiteTermos?: string
  presencaPaciente?: string
  inicioFormatado?: string
  terminoFormatado?: string
  solicitacaoFormatada?: string
  aceiteTermosFormatado?: string
  presencaPacienteFormatada?: string
  resultado?: string
  pacienteOnline?: boolean
  estado?: EstadoAtendimentoDto
  especialidade?: EspecialidadeDto
  paciente?: PacienteDto
  dadosAso?: AtendimentoDtoDadosAso
  anotacoes?: AtendimentoDtoAnotacao[]
  mensagens?: AtendimentoDtoMensagem[]
  informacoes?: AtendimentoDtoInformacao[]
  procedimentos?: AtendimentoDtoProcedimento[]
  prescricoes?: AtendimentoDtoPrescricao[]
  formularios?: AtendimentoDtoFormulario[]
  anexos?: AtendimentoDtoAnexo[]
  fatoresRisco?: AtendimentoDtoFatorRisco[]
  cids?: AtendimentoDtoCid[]
  urlAtendimento?: string
  /** Interconsulta: lotação do solicitante carimbada na abertura; `null` quando não determinada. */
  lotacaoSolicitante?: AtendimentoDtoLotacao | null
}

/**
 * Lotação na resposta da abertura (`AtendimentoDtoLotacao`). Diferente da `LotacaoView`: aqui o CBO
 * vem achatado em código e descrição.
 */
export type AtendimentoDtoLotacao = {
  id: number
  unidade?: { id?: number; nome?: string } | null
  cbo?: string | null
  descricaoCbo?: string | null
  ine?: string | null
}

/**
 * CBO exibido no seletor de lotação do encerramento (par código/descrição vindo de
 * `EsusEncerramentoCboDto`). Não é o `CboView` do cadastro de funcionários: o contexto de
 * encerramento não expõe o id interno do CBO, porque o que identifica a escolha no PUT é o id da
 * lotação.
 */
export type EsusEncerramentoCboView = {
  codigo: string
  descricao?: string
}

/**
 * Opção do seletor de lotação do encerramento (`EsusEncerramentoLotacaoDto`).
 *
 * `id` é exatamente o valor aceito no campo `lotacao` do PUT de encerramento e `ultimaUsada` é a
 * sugestão de pré-seleção calculada no backend (AC12 de E1c) — a UI não deriva isso sozinha.
 */
export type EsusEncerramentoLotacaoView = {
  id: number
  cbo?: EsusEncerramentoCboView
  ine?: string
  ultimaUsada: boolean
}

/** Conduta da lista fechada do e-SUS (enum `CondutaEsus`, serializado como objeto). */
export type EsusCondutaView = {
  codigo: number
  descricao: string
}

/**
 * Linha do bloco somente leitura de procedimentos do encerramento (`EsusEncerramentoProcedimentoDto`).
 *
 * A lista é **derivada** no backend das aferições do atendimento (fonte única `ProcedimentoEsus`) — o
 * frontend não deriva, não ordena e não edita nada: só mostra o que vai ser enviado em nome do
 * profissional.
 */
export type EsusEncerramentoProcedimentoView = {
  descricao: string
  codigo: string
  quantidade: number
}

/**
 * Resposta de `GET /atendimentos/{id}/esus-encerramento` (E1d): tudo que o bloco e-SUS do
 * encerramento precisa, autorizado pela mesma permissão de leitura do atendimento.
 *
 * `esusAtivo` é o único sinal que decide se o bloco aparece — `lotacoes` e `condutas` vêm sempre
 * preenchidas, mesmo com a integração desligada.
 *
 * `procedimentos` (F3) é **opcional de propósito**: backend mais antigo não manda a chave, e o bloco
 * simplesmente não aparece — degradação graciosa, sem `!` e sem quebrar o encerramento. É também o
 * que mantém válidos os literais de fallback `{ esusAtivo: false, lotacoes: [], condutas: [] }` de
 * `AsideMenuAtendimentoMain`.
 */
export type AtendimentoEsusContexto = {
  esusAtivo: boolean
  lotacoes: EsusEncerramentoLotacaoView[]
  condutas: EsusCondutaView[]
  procedimentos?: EsusEncerramentoProcedimentoView[]
}

export type AtendimentoPacienteQueryResponse = Response<Array<AtendimentoPacienteList>>

export type AtendimentosQueryResponse = Response<Array<AtendimentoList>>

export type CIDQueryResponse = Response<Array<CidList>>

export type EstadosDeAtendimentoQueryResponse = Response<Array<EstadoAtendimentoList>>

export const initialAtendimento: AtendimentoView = {
  id: -1,
}

/**
 * Interrupção de teleconsulta declarada pelo profissional.
 *
 * `causa` e `quemCaiu` são códigos do catálogo servido pelo backend
 * (`/tipos/atendimento/interrupcao/*`) — não existe enum paralelo no front.
 * `origem` nunca é enviada: o backend grava sempre `DECLARADA`.
 */
export type InterrupcaoAtendimentoDtoCreate = {
  dhInicio: string
  dhFim?: string | null
  causa: string
  causaDetalhe?: string | null
  quemCaiu: string
  retomada: boolean
  idInterrupcaoRetificada?: number | null
}

export type InterrupcaoAtendimentoView = {
  id: number
  dhInicio: string
  dhFim?: string | null
  origem: string
  origemDescricao?: string
  causa: string
  causaDescricao?: string
  causaDetalhe?: string | null
  quemCaiu: string
  quemCaiuDescricao?: string
  retomada: boolean
  idInterrupcaoRetificada?: number | null
  duracaoMinutos?: number | null
  createdAt?: string
  createdBy?: number
}

export type TranscricaoAtendimentoView = {
  id: number
  situacao: SituacaoTranscricaoType
  textoConsolidado?: string
  dtInicio: string
  dtFim?: string
  duracaoSegundos?: number
}

// ---- Exames de imagem DICOM (enums saem pelo nome da constante Java) ----

export type SituacaoSolicitacaoExameImagem = 'AGUARDANDO' | 'RECEBIDO' | 'CANCELADO'

export type MotivoCancelamentoSolicitacao =
  | 'USUARIO'
  | 'SUBSTITUICAO'
  | 'ENCERRAMENTO'
  | 'EXPIRACAO'

export type SituacaoWorklist = 'PENDENTE' | 'PUBLICADO' | 'REMOVIDO' | 'ERRO'

export type SituacaoVinculoEstudo = 'VINCULADO' | 'NAO_VINCULADO' | 'QUARENTENA'

export type OrigemVinculoEstudo = 'AUTOMATICO' | 'MANUAL'

/** Dispositivo DICOM de um Telekit (`/telekits/{id}/dispositivos` com AE Title), disponível para o pedido. */
export type TelekitDispositivoDicom = {
  id: number
  aeTitle: string
  descricao: string | null
  modalidade: string
  dispositivo: { id: number; descricao: string; serie: string; tipo: string }
  telekit: {
    id: number
    identificador: number
    empresa: { id: number; nome: string }
  }
}

export type SolicitacaoExameImagem = {
  id: number
  sequencia: number
  accessionNumber: string
  studyInstanceUid: string
  modalidade: string
  dataAgendada: string
  situacao: SituacaoSolicitacaoExameImagem
  motivoCancelamento: MotivoCancelamentoSolicitacao | null
  situacaoWorklist: SituacaoWorklist | null
  telekitDispositivo: TelekitDispositivoDicom
}

export type EstudoDicom = {
  id: number
  studyInstanceUid: string
  accessionNumber: string | null
  modalidade: string | null
  dataEstudo: string | null
  quantidadeSeries: number | null
  quantidadeInstancias: number | null
  situacaoVinculo: SituacaoVinculoEstudo
  origemVinculo: OrigemVinculoEstudo | null
  dataVinculo: string | null
  solicitacao: { id: number } | null
}

export type ExamesImagemAtendimento = {
  solicitacoes: Response<SolicitacaoExameImagem[]>
  estudos: EstudoDicom[]
}

/** `criada` distingue o 201 (pedido novo) do 200 (pedido já aguardando no mesmo dispositivo). */
export type ResultadoSolicitacaoExameImagem = {
  criada: boolean
  solicitacao: SolicitacaoExameImagem
}

/** Objeto DICOM JSON (PS3.18 F.2): tag de 8 dígitos hex -> VR e valores. */
export type DicomJsonObjeto = Record<string, { vr: string; Value?: unknown[] }>
